module.exports = __webpack_public_path__ + "static/media/projectBannerLEDInspector.79ed9eb0.png";